export const CrmObjectMetaTypes = Object.freeze({
  HUBSPOT: 'HUBSPOT',
  PORTAL_SPECIFIC: 'PORTAL_SPECIFIC',
  INTEGRATION: 'INTEGRATION'
});